import { Control } from './control';
import { AlarmAction } from './alarm-action';

export class AlarmControl {
  constructor(
    public hash?: string,
    public description?: string,
    public alarmTxt?: string,
    public action?: AlarmAction,
    public control?: Control
  ) { }

  clone() {
    return new AlarmControl(
      this.hash,
      this.description,
      this.alarmTxt,
      this.action,
      this.control
    );
  }

  get controlName() {
    return this.control ? this.control.name : '';
  }

  get actionName() {
    return this.action ? this.action.name : '';
  }

  get filterableData() {
    return `${ this.description } ${ this.alarmTxt } ${ this.action.name } ${ this.control.name }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/alarm-control.ts